export default {
    modalQuickActionVariations: {
        title: 'IA',
        generateWithAi: 'Generar con IA',
        improveWriting: 'Mejorar la escritura',
        fixSpelling: 'Arreglar ortografía y gramática',
        simplifyWriting: 'Simplificar la escritura',
        makeLonger: 'Alargar',
        makeShorter: 'Acortar',
        replaceText: 'Reemplazar texto',
        addBelow: 'Agregar abajo',
        cancel: 'Cancelar',
        selectQuickActionTitle: 'Dile a la IA qué hacer a continuación...',
        regenerate: 'Regenerar',
    },
};
